import React from 'react';
import { Helmet } from 'react-helmet';

export default () => (
  <div>
    <Helmet>
      <title>QR</title>
    </Helmet>
    QR
  </div>
);
